import APIRequest from '../../helpers/apiHelpers'
// import request from 'superagent'
import { toast } from 'react-toastify'
import { get } from 'lodash'
import { decodeEntities } from '../../helpers/stringHelpers'
import blxListingSales from '../../actions/listingSales'

const woaListingSales = {
  placeDirectWebcastBid: (auctionId, registrantId, listingId, bidValue, uid) => {
    return (dispatch, getState) => {
      const { apiBase, clientId } = getState().config.input.config
      dispatch({
        type: 'LOT_SALE_BID'
      })
      return APIRequest.post(apiBase, clientId, `webcast2/placeBid/${auctionId}/${listingId}/${registrantId}/${bidValue * 100}?uid=${uid}`, {}, 2)
        .then(res => {
          if (res?.body?.worked) {
            return dispatch({
              type: 'LOT_SALE_BID_SUCCESS'
            })
          }
          dispatch({
            type: 'LOT_SALE_BID_FAILED',
            err: new Error(res.body.message)
          })
          toast.warning(res.body.message, {
            autoClose: 10000
          })
        })
        .catch(err => {
          console.error(err)
          dispatch({
            type: 'LOT_SALE_BID_FAILED',
            err
          })
          let errorMessage
          try {
            errorMessage = JSON.parse(err.message).message
          } catch (e) {
            errorMessage = err.message
          }
          toast.error(decodeEntities(errorMessage), {
            autoClose: 10000
          })
          throw err
        })
    }
  },
  placeDirectBid: (listingId, registrantId, userId, bidValue) => {
    return (dispatch, getState) => {
      const { apiBase, clientId } = getState().config.input.config
      dispatch({
        type: 'LOT_SALE_BID'
      })
      return APIRequest.post(apiBase, clientId, `timed/bid/${listingId}/${registrantId}/${userId}/${bidValue}`)
        .then(res => {
          if (res.body.worked && !res.body.models.ErrorModel) {
            return dispatch({
              type: 'LOT_SALE_BID_SUCCESS'
            })
          }
          const errorMessage = get(res.body, 'models.ErrorModel.message', res.body.message)
          throw new Error(errorMessage)
        })
        .catch(err => {
          console.error(err)
          dispatch({
            type: 'LOT_SALE_BID_FAILED',
            err
          })
          let errorMessage
          try {
            errorMessage = JSON.parse(err.message).message
          } catch (e) {
            errorMessage = err.message
          }
          toast.warning(decodeEntities(errorMessage), {
            autoClose: 10000
          })
          throw err
        })
    }
  }
  // getCustomIncrements: (auctionUuid, listingUuid) => {
  //   return async (dispatch, getState) => {
  //     const { apiBase, clientId } = getState().config.input.config
  //     const oAuthConfig = getState().config.input.options.oAuth
  //     dispatch({
  //       type: 'LISTING_SALE_GET_INCREMENTS'
  //     })

  //     try {
  //       const timestamp = new Date().getTime()
  //       const increments = {}

  //       let fetchIncrements = await request.get(`${oAuthConfig.ssoLoginUrl}/increments?auction_uuid=${auctionUuid}&t=${timestamp}`)
  //         .then(res => {
  //           return get(res, 'body.increments.' + auctionUuid + '.' + listingUuid) || get(res, 'body.increments.' + auctionUuid) || get(res, 'body.increments.0')
  //         }).catch(() => null)
  //       if (!fetchIncrements) {
  //         const res = await APIRequest.get(apiBase, clientId, `bid/increments/${listingUuid}`)
  //         fetchIncrements = res.body.increments
  //       }

  //       if (!fetchIncrements) {
  //         throw new Error('No increments found')
  //       }

  //       // divide by 100, due to it always being in pence
  //       for (const key in fetchIncrements) {
  //         if (Object.hasOwnProperty.call(fetchIncrements, key)) {
  //           increments[key / 100] = fetchIncrements[key] / 100
  //         }
  //       }

  //       return dispatch({
  //         type: 'LISTING_SALE_GET_INCREMENTS_SUCCESS',
  //         increments,
  //         listingUuid
  //       })
  //     } catch (err) {
  //       console.error(err)
  //       dispatch({
  //         type: 'LISTING_SALE_GET_INCREMENTS_FAILED',
  //         err
  //       })
  //       throw err
  //     }
  //   }
  // }
}

const listingSales = {
  ...blxListingSales,
  ...woaListingSales
}

export default listingSales
